<template>
    <div class="integration">
        <div v-if="!selectedIntegration" class="no integration-card">
            <span>{{$t("SelectIntegration")}}</span>
        </div>
        <div v-if="!!selectedIntegration" class="integration-info-container">
            <object-main-info :fields="fields" :identifier="cardObjectIdentifier" :identifier-label="$tc('Label', 1)"
                :height="cardHeight">
            </object-main-info>
            <integration-specific-info v-if="!showPermissions" :custom="selectedIntegration.custom_attributes ? getIntegrationCustomParams : []"
                :auth="selectedIntegration.auth_params_json ? getIntegrationAuthParams : []"/>
        </div>
    </div>
</template>
  
<script>

import _ from 'lodash';
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import ObjectMainInfo from '@/newComponents/_Organisms/ObjectMainInfo';
import IntegrationSpecificInfo from '@/newComponents/Integrations/IntegrationSpecificInfo.vue';
export default {
    name: "Integration",

    components: {
        ObjectMainInfo,
        IntegrationSpecificInfo,
    },

    mixins: [checkPermissionsMixin],

    props: {
        selectedIntegration: {
            type: Object,
        },
    },

    data() {
        return {
            showPermissions: false,
        }
    },

    computed: {
        fields() {
            let fields = [];
            if (this.selectedIntegration !== null && !this.showPermissions) {
                fields = [
                    {
                        icon: "mdi-shape",
                        label: this.$i18n.tc("Type", 1),
                        value: this.selectedIntegration.integration_type,
                        varName: 'type',
                        inputType: 'text',
                        disabled: false,
                        required: false,
                        size: '100%',
                    },
                    {
                        icon: "subject",
                        label: this.$i18n.t("Description"),
                        value: this.selectedIntegration.description,
                        varName: 'description',
                        inputType: 'text',
                        disabled: false,
                        required: false,
                        size: '100%',
                    },

                    {
                        icon: "mdi-layers",
                        label: this.$i18n.tc("Layer", 2),
                        value: this.selectedIntegration.layers,
                        varName: 'layers',
                        inputType: 'text',
                        disabled: false,
                        required: false,
                        size: '100%',
                    },
                    {
                        icon: "mdi-power",
                        label: this.$i18n.t("Active"),
                        value: this.selectedIntegration.active,
                        varName: 'active',
                        inputType: 'text',
                        disabled: false,
                        required: false,
                        size: '100%',
                    },
                    {
                        icon: "mdi-eye",
                        label: this.$i18n.t("Visible"),
                        value: this.selectedIntegration.visible,
                        varName: 'active',
                        inputType: 'text',
                        disabled: false,
                        required: false,
                        size: '100%',
                    },
                    {
                        icon: "mdi-format-list-bulleted",
                        label: this.$i18n.t("Index"),
                        value: this.selectedIntegration.index,
                        varName: 'index',
                        inputType: 'text',
                        disabled: false,
                        required: false,
                        size: '100%',
                    },
                    {
                        icon: "mdi-calendar",
                        label: this.$i18n.t("UpdateDate"),
                        value: this.selectedIntegration.updated_at ? this.dateFormatter(this.selectedIntegration.updated_at) : "",
                        varName: 'updateDate',
                        inputType: 'text',
                        disabled: false,
                        required: false,
                        size: '100%',
                    },
                    {
                        icon: "person",
                        label: this.$i18n.t("UpdatedBy"),
                        value: this.selectedIntegration.updated_by,
                        varName: 'updatedBy',
                        inputType: 'text',
                        disabled: false,
                        required: false,
                        size: '100%',
                    },
                ];
            }
            return fields;
        },

        cardObjectIdentifier() {
            if (this.selectedIntegration) {
                if (this.showPermissions) {
                    return this.$i18n.tc("Permission", 2) + ': ' + this.selectedIntegration.name
                }
                return this.selectedIntegration.name;
            }
            return "";
        },

        cardHeight() {
            return '40%'
        },

        getIntegrationAuthParams() {
            let authAttributeArray = [];
            let authAttributes = JSON.parse(this.selectedIntegration.auth_params_json);
            for (let key in authAttributes) {
                if (authAttributes.hasOwnProperty(key)) {
                    authAttributeArray.push({
                        attribute: key,
                        value: authAttributes[key],
                        isPassword: (key.includes('password') || key.includes('secret'))
                    });
                }
            }
            return authAttributeArray;
        },

        getIntegrationCustomParams() {
            let customAttributeArray = [];
            let customAttributes = JSON.parse(this.selectedIntegration.custom_attributes);
            for (let key in customAttributes) {
                if (customAttributes.hasOwnProperty(key)) {
                    customAttributeArray.push({
                        attribute: key,
                        value: customAttributes[key],
                        isPassword: (key === 'username_password_base64') || (key === 'password')
                    });
                }
            }
            return customAttributeArray;
        }
    },

    methods: {
        dateFormatter(date) {
            const dateArray = date.split(" ");
            return dateArray[0] + " / " + dateArray[1];
        },

        requiredFieldsValidation() {
            return true;
        },
    },
}
</script>

<style scoped>
.integration {
    height: 100%;
    max-height: 100%;
    background-color: #fff;
    position: relative;
    border-radius: 8px;
}

.integration-card {
    height: 100%;
}

.integration-card {
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
}

.no.integration-card {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
}

.no.integration-card>span {
    color: #29BDF0;
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    line-height: normal;
}

.integration-info-container {
    gap: 8px;
    display: flex;
    flex-direction: column;
    max-height: 100%;
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/newComponents/Integrations/Integration.vue